/**
 * Uzbek strings: the only locale for now.
 *
 * Wording is taken verbatim from the Kapitan prototype; do not paraphrase it.
 * Keys are `<area>.<thing>`. Placeholders use `{name}` and are filled by `t()`.
 */
import { uzB12Ai } from "./uz-b12-ai";
import { uzB12Settings } from "./uz-b12-settings";
import { uzB12Moliya } from "./uz-b12-moliya";
import { uzB12Auth } from "./uz-b12-auth";
import { uzB12Bookings } from "./uz-b12-bookings";
import { uzB12Foundation } from "./uz-b12-foundation";
import { uzB12Inbox } from "./uz-b12-inbox";
import { uzB12Deals } from "./uz-b12-deals";
import { uzB12Clients } from "./uz-b12-clients";
import { uzB12Home } from "./uz-b12-home";
import { uzB12Reports } from "./uz-b12-reports";
import { uzB12Tasks } from "./uz-b12-tasks";
import { uzB12Automation } from "./uz-b12-automation";
import { uzB12Platform } from "./uz-b12-platform";
import { uzB12Holatlar } from "./uz-b12-holatlar";
import { uzB12Platform2 } from "./uz-b12-platform2";
import { uzB12Search } from "./uz-b12-search";
import { uzInbox09 } from "./uz-09-inbox";
import { uzTourInfo09 } from "./uz-09-tour-info";
import { uzDealsBoard } from "./uz-deals-board";
import { uzSettingsFinance } from "./uz-settings-finance";
import { uzClientInboxW1 } from "./uz-w1-client-inbox";
import { uzChannelsW2 } from "./uz-w2-channels";
import { uzBookingsW2 } from "./uz-w2-bookings";
import { uzAgentW2 } from "./uz-w2-agent";
import { uzAiFiles } from "./uz-ai-files";

export const uz = {
  ...uzB12Ai,
  ...uzB12Settings,
  ...uzB12Moliya,
  ...uzInbox09,
  ...uzB12Home,
  ...uzB12Reports,
  ...uzB12Automation,
  ...uzB12Platform,
  ...uzB12Platform2,
  ...uzB12Holatlar,
  ...uzB12Tasks,
  ...uzB12Clients,
  ...uzB12Foundation,
  ...uzB12Inbox,
  ...uzB12Deals,
  ...uzB12Auth,
  ...uzB12Bookings,
  ...uzB12Search,
  ...uzTourInfo09,
  ...uzDealsBoard,
  ...uzSettingsFinance,
  ...uzClientInboxW1,
  ...uzChannelsW2,
  ...uzBookingsW2,
  ...uzAgentW2,
  ...uzAiFiles,
  "app.name": "Kapitan",

  // ---------------------------------------------------------------- navigation
  "nav.group.main": "Asosiy",
  "nav.group.management": "Boshqaruv",
  "nav.home": "Bosh sahifa",
  "nav.conversations": "Suhbatlar",
  "nav.deals": "Bitimlar",
  "nav.clients": "Mijozlar",
  "nav.tourSearch": "Tur qidiruvi",
  "nav.finance": "Moliya",
  "nav.reports": "Hisobotlar",
  "nav.myReport": "Mening hisobotim",
  "nav.settings": "Sozlamalar",
  "nav.contractTemplates": "Shablonlar",
  "nav.destinations": "Yo'nalishlar",

  // ---------------------------------------------------------------- roles
  "role.operator": "Operator",
  "role.branch_manager": "Menejer",
  "role.moliyachi": "Moliyachi",
  "role.owner": "Egasi",
  "role.operator.hint": "Suhbatlar, bitimlar",
  "role.branch_manager.hint": "Filial, jamoa, hisobotlar",
  "role.moliyachi.hint": "Kassa, to'lovlar, tasdiqlash",
  "role.owner.hint": "Barcha filiallar, moliya",

  // ---------------------------------------------------------------- auth
  "auth.welcome": "Xush kelibsiz",
  "auth.subtitle": "Hisobingizga kiring va ishni davom ettiring",
  "auth.email": "Email",
  "auth.password": "Parol",
  "auth.remember": "Meni eslab qol",
  "auth.submit": "Kirish",
  "auth.submitting": "Kirilmoqda…",
  "auth.forgot": "Parolni unutdingizmi?",
  "auth.invalidCredentials": "Email yoki parol noto'g'ri. Qayta urinib ko'ring.",
  "auth.noMembership": "Bu hisob hech qanday agentlikka ulanmagan",
  "auth.logout": "Chiqish",
  "auth.tagline": "Qidiruvdan tayyor taklifgacha bir necha daqiqa",
  "auth.title": "Kirish",

  // ---------------------------------------------------------------- finance
  "finance.title": "Moliya",
  "finance.subtitle": "Kassa, to'lovlar va chiqimlar",
  "finance.tab.payments": "To'lovlar",
  "finance.tab.expenses": "Chiqimlar",
  "finance.tab.approvals": "Tasdiq navbati",
  "finance.tab.vendors": "Ta'minotchilar",
  "finance.today.income": "Bugun tushum",
  "finance.today.overdue": "Kechikkan to'lovlar",
  "finance.today.pending": "Tasdiq kutilmoqda",
  "finance.noMovement": "harakat yo'q",
  "finance.todaySuffix": "bugun",
  "finance.openingBalance": "Boshlang'ich qoldiq",
  "finance.operatorNotice":
    "Siz faqat o'z bitimlaringizga to'lov kiritishingiz mumkin. Kassa balanslari va chiqimlar moliyachi uchun.",

  "payment.filter.all": "Hammasi",
  "payment.filter.pending": "Tasdiq kutilmoqda",
  "payment.filter.overdue": "Kechikkan",
  "payment.filter.paid": "To'landi",
  "payment.column.clientDeal": "Mijoz / bitim",
  "payment.column.amount": "Summa",
  "payment.column.account": "Kassa / usul",
  "payment.column.due": "Muddat",
  "payment.column.status": "Holat",
  "payment.status.pendingApproval": "Tasdiq kutilmoqda",
  "payment.status.expected": "Kutilmoqda",
  "payment.status.overdue": "Kechikkan",
  "payment.status.paid": "To'landi",
  "payment.status.rejected": "Rad etildi",
  "payment.status.storno": "Storno",
  "payment.action.approve": "Tasdiqlash",
  "payment.action.reject": "Rad etish",
  "payment.action.cancel": "Bekor qilish",
  "payment.action.create": "+ To'lov kiritish",
  "payment.noDelete": "To'lov o'chirilmaydi",
  "payment.noDeleteHint":
    "«Bekor qilish» sabab so'raydi va teskari yozuv (storno) yaratadi; ikkalasi ham tarixda qoladi.",
  "payment.empty": "To'lovlar yo'q",
  "payment.stornoOf": "Storno · sabab: {reason}",
  "payment.enteredBy": "Kiritdi: {name}",

  "paymentForm.title": "To'lov kiritish",
  "paymentForm.deal": "Bitim",
  "paymentForm.dealPlaceholder": "Bitimni tanlang",
  "paymentForm.amount": "Summa",
  "paymentForm.account": "Kassa / usul",
  "paymentForm.currency": "Valyuta",
  "paymentForm.dealCurrency": "Bitim valyutasi: {currency}",
  "paymentForm.date": "Sana",
  "paymentForm.note": "Izoh",
  "paymentForm.installment": "Qaysi bo'lakka",
  "paymentForm.noInstallment": "Bo'lakka bog'lamaslik",
  "paymentForm.hint":
    "Kiritilgandan keyin bo'lak holati avtomatik yangilanadi. Operator kiritgan to'lov «Tasdiq kutilmoqda» holatida bo'ladi.",
  "paymentForm.rateLine": "{uzs} · kurs {rate}",
  "paymentForm.rateLineWithEquivalent": "{uzs} · {amount} ekv. · kurs {rate}",
  "paymentForm.equivalent": "{amount} ekv. · kurs {rate}",
  "paymentForm.currencyFromAccount": "Valyuta kassa bo'yicha aniqlanadi",
  "paymentForm.rateMissing":
    "{date} sanasi uchun CBU kursi topilmadi. Bu sana bilan to'lov kiritilmaydi.",
  "paymentForm.hintFinance":
    "Siz kiritgan to'lov darhol hisobga olinadi va kassa balansiga tushadi.",

  "reason.title": "Sababni ko'rsating",
  "reason.label": "Sabab",
  "reason.rejectTitle": "To'lovni rad etish",
  "reason.stornoTitle": "To'lovni bekor qilish (storno)",
  "reason.stornoHint":
    "Asl yozuv o'chirilmaydi. Uning teskarisi yaratiladi va ikkalasi tarixda qoladi.",

  "expense.action.create": "+ Chiqim kiritish",
  "expense.column.date": "Sana",
  "expense.column.category": "Kategoriya",
  "expense.column.amount": "Summa",
  "expense.column.account": "Kassa",
  "expense.column.vendor": "Ta'minotchi",
  "expense.column.note": "Izoh",
  "expense.empty": "Chiqimlar yo'q",
  "expenseForm.title": "Chiqim kiritish",
  "expenseForm.category": "Kategoriya",
  "expenseForm.vendor": "Ta'minotchi",
  "expenseForm.deal": "Bitim (ixtiyoriy)",
  "expenseForm.vendorRequired": "Bu kategoriya uchun ta'minotchi shart",

  "vendors.column.name": "Nomi",
  "vendors.column.phone": "Telefon",
  "vendors.column.note": "Izoh",
  "vendors.empty": "Ta'minotchilar yo'q",

  "approvals.empty": "Tasdiq kutayotgan to'lovlar yo'q",
  "approvals.count": "{count} ta to'lov tasdiqlashni kutmoqda",

  // ---------------------------------------------------------------- clients
  "clients.title": "Mijozlar",
  "clients.subtitle": "Mijozlar bazasi va qo'ng'iroqlar jurnali",
  "clients.column.name": "Ism",
  "clients.column.phone": "Telefon",
  "clients.column.lastActivity": "Oxirgi faollik",
  "clients.column.deals": "Bitimlar",
  "clients.column.total": "Summa",
  "clients.column.discipline": "Intizom",
  "clients.column.tags": "Teglar",
  "clients.column.owner": "Mas'ul",
  "clients.empty": "Mijozlar yo'q",
  "clients.card.title": "Mijoz kartochkasi",
  "clients.card.back": "Mijozlar",

  "discipline.new": "Yangi",
  "discipline.a": "A",
  "discipline.b": "B",
  "discipline.c": "C",
  "discipline.title": "To'lov intizomi",
  "discipline.avgCheck": "O'rtacha chek",
  "discipline.lateCount": "Kechikkan to'lovlar",
  "discipline.cancelCount": "Bekor qilingan bitimlar",
  "discipline.tripsCount": "Sayohatlar",
  "discipline.computedAt": "Hisoblangan: {date}",
  "discipline.override": "Qo'lda belgilangan",
  "discipline.overrideLabel": "Qo'lda belgilash",
  "discipline.overrideClear": "Bekor qilish",
  "discipline.hint":
    "Intizom faqat ma'lumot uchun. Hech qanday cheklov qo'ymaydi va mijozga ko'rsatilmaydi.",
  "discipline.rules":
    "Qoida: 2 dan kam yopilgan bitim bo'lsa, «Yangi». Kechikish va bekor qilish bo'lmasa, A. 2 tagacha kechikish va 1 tagacha bekor qilish bo'lsa, B. Qolgani C.",

  // ---------------------------------------------------------------- deals
  "deals.title": "Bitimlar",
  "deals.subtitle": "Ochiq bitimlar va ularning bosqichlari",
  "deals.view.kanban": "Kanban",
  "deals.view.table": "Jadval",
  "deals.tab.payments": "To'lovlar",
  "deals.total": "Jami",
  "deals.paid": "To'langan",
  "deals.remaining": "Qoldiq",
  "deals.expected": "Kutilayotgan to'lovlar",
  "deals.expectedAdd": "+ Bo'lak qo'shish",
  "deals.expectedEmpty": "Bo'laklar belgilanmagan",
  "deals.expectedSettled": "To'landi",
  "deals.expectedOverdue": "Kechikkan",
  "deals.empty": "Bitimlar yo'q",
  "deals.pax": "{count} kishi",
  "deals.dragHint": "Bosqichni o'zgartirish uchun torting",
  "deals.next": "Keyingi bosqichga",
  "deals.lost": "Yo'qotilganga o'tkazish",
  "deals.lost.title": "Yo'qotilganga o'tkazish",
  "deals.lost.reason": "Sabab",
  "deals.lost.placeholder": "Sababni tanlang",
  "deals.lost.confirm": "Yo'qotilganga o'tkazish",
  "deals.lost.cancel": "Bekor qilish",
  "deals.moveFailed": "Bosqichni o'zgartirib bo'lmadi",
  "deals.breadcrumb": "Bitimlar",
  "deals.tab.general": "Umumiy",
  "deals.tab.travelers": "Sayohatchilar",
  "deals.tab.booking": "Bron",
  "deals.tab.offers": "Takliflar",
  "deals.tab.documents": "Hujjatlar",
  "deals.tab.messages": "Yozishma",
  "deals.tab.later": "keyingi bosqichda",
  "deals.nextStep": "Keyingi qadam",
  "deals.nextStep.empty": "Keyingi qadam belgilanmagan",
  "deals.nextStep.due": "Muddat",
  "deals.nextStep.save": "Saqlash",
  "deals.activity": "Izohlar va faoliyat",
  "deals.activity.staffOnly": "Izohlar faqat xodimlarga ko'rinadi",
  "deals.activity.placeholder": "Izoh yozing…",
  "deals.activity.send": "Qo'shish",
  "deals.activity.empty": "Hozircha izoh yo'q",
  "deals.activity.system": "Tizim",
  "deals.travelers.empty": "Sayohatchilar kiritilmagan",
  "deals.travelers.passport": "Pasport",
  "deals.general.destination": "Manzil",
  "deals.general.dates": "Sanalar",
  "deals.general.pax": "Sayohatchilar",
  "deals.general.price": "Summa",
  "deals.general.netto": "Netto",
  "deals.general.branch": "Filial",
  "deals.general.assignee": "Mas'ul",
  "deals.general.lostReason": "Yo'qotish sababi",
  "deals.nights": "{count} kun",
  "deals.margin": "Marja {amount}",
  "deals.netto": "Netto {amount}",

  // ---------------------------------------------------------------- reports
  // ---------------------------------------------------------------- tur qidiruvi
  // Provayder yorliqlari (mehmonxona, ovqat, dastur nomlari) tarjima qilinmaydi:
  // ular operator ta'minotchining o'z tizimida ko'radigan matnlar.
  "tours.title": "Tur qidiruvi",
  "tours.subtitle": "SelfieTravel bo'yicha narxlar va bronlar",
  "tours.tab.search": "Qidiruv",
  "tours.tab.claims": "Bronlar",
  "tours.field.from": "Qayerdan",
  "tours.field.to": "Qayerga",
  "tours.field.program": "Dastur",
  "tours.field.checkInFrom": "Sana (dan)",
  "tours.field.checkInTo": "Sana (gacha)",
  "tours.field.nights": "Kechalar (dan / gacha)",
  "tours.field.adults": "Kattalar",
  "tours.search": "Qidirish",
  "tours.searching": "Qidirilmoqda...",
  "tours.loading": "Olinmoqda...",
  "tours.loadFailed": "Yuklanmadi",
  "tours.hint": "Yo'nalish va dasturni tanlab, Qidirish tugmasini bosing.",
  "tours.empty": "Bu shartlar bo'yicha taklif topilmadi",
  "tours.claims.empty": "Bronlar yo'q",
  "tours.col.date": "Sana",
  "tours.col.hotel": "Mehmonxona",
  "tours.col.nights": "Kecha",
  "tours.col.meal": "Ovqat",
  "tours.col.room": "Xona",
  "tours.col.price": "Narx",
  "tours.col.claim": "Raqam",
  "tours.col.tour": "Tur",
  "tours.col.dates": "Sanalar",
  "tours.col.status": "Holat",

  "reports.title": "Hisobotlar",
  "reports.subtitle": "Davr va filial bo'yicha tahlil",

  "reports.section.dynamics": "Tushum-chiqim dinamikasi",
  "reports.section.margin": "Marja",
  "reports.section.debtors": "Qarzdorlar va kutilayotgan to'lovlar",
  "reports.section.workload": "Yuklama va KPI",
  "reports.section.branches": "Filiallar taqqoslash",

  "reports.filter.period": "Davr",
  "reports.filter.branch": "Filial",
  "reports.filter.currency": "Valyuta",
  "reports.filter.from": "dan",
  "reports.filter.to": "gacha",
  "reports.period.thisMonth": "Shu oy",
  "reports.period.lastMonth": "O'tgan oy",
  "reports.period.days90": "90 kun",
  "reports.period.thisYear": "Shu yil",
  "reports.branch.all": "Barcha filiallar",
  "reports.branchLocked": "Siz o'z filialingiz ma'lumotlarini ko'rasiz",

  "reports.uzsOnly": "Bu ko'rsatkich doim so'mda, saqlangan ekvivalentlar bo'yicha.",
  "reports.empty": "Tanlangan davr uchun ma'lumot yo'q",

  "reports.dynamics.income": "Tushum",
  "reports.dynamics.expense": "Chiqim",
  "reports.dynamics.net": "Sof",
  "reports.dynamics.total": "Davr bo'yicha jami",
  "reports.dynamics.granularity.day": "Kunlik",
  "reports.dynamics.granularity.month": "Oylik",

  "reports.margin.byDestination": "Manzil bo'yicha",
  "reports.margin.byVendor": "Ta'minotchi bo'yicha",
  "reports.margin.destination": "Manzil",
  "reports.margin.vendor": "Ta'minotchi",
  "reports.margin.deals": "Bitimlar",
  "reports.margin.revenue": "Tushum",
  "reports.margin.cost": "Netto",
  "reports.margin.margin": "Marja",
  "reports.margin.percent": "MARJA %",
  "reports.margin.collected": "Yig'ildi (so'm)",
  "reports.margin.currencyNote":
    "Bitim narxi va nettosi saqlangan so'm ekvivalentiga ega emas, shuning uchun ular valyuta bo'yicha alohida ko'rsatiladi.",

  "reports.debtors.title": "Qarzdorlar",
  "reports.debtors.client": "Mijoz",
  "reports.debtors.destination": "Manzil",
  "reports.debtors.price": "Narx",
  "reports.debtors.paid": "To'langan",
  "reports.debtors.remaining": "Qoldiq",
  "reports.debtors.next": "Keyingi muddat",
  "reports.debtors.empty": "Qarzdorlar yo'q",
  "reports.upcoming.title": "Kutilayotgan to'lovlar",
  "reports.upcoming.amount": "Summa",
  "reports.upcoming.date": "Muddat",
  "reports.upcoming.empty": "Kutilayotgan to'lovlar yo'q",

  "reports.workload.manager": "Mas'ul",
  "reports.workload.closed": "Yopilgan",
  "reports.workload.revenue": "Tushum (shartnoma)",
  "reports.workload.collected": "Yig'ildi (so'm)",
  "reports.workload.note":
    "Bitimni yopish pul olish degani emas. Shartnoma summasi va haqiqatda yig'ilgan pul alohida ko'rsatiladi.",

  "reports.branches.branch": "Filial",
  "reports.branches.open": "Ochiq",
  "reports.branches.won": "Yopilgan",
  "reports.branches.revenue": "Tushum",
  "reports.branches.margin": "Marja",
  "reports.branches.collected": "Yig'ildi (so'm)",
  "reports.branches.ownerOnly": "Faqat egasi uchun",

  // ---------------------------------------------------------------- common
  "app.crash.message": "Kutilmagan xato yuz berdi. Sahifani qayta yuklang.",
  "app.crash.reload": "Qayta yuklash",
  "common.save": "Saqlash",
  "common.saving": "Saqlanmoqda…",
  "common.cancel": "Bekor qilish",
  "common.confirm": "Tasdiqlash",
  "common.close": "Yopish",
  "common.search": "Qidirish…",
  "common.create": "+ Yaratish",
  "common.allBranches": "Barcha filiallar",
  "common.loading": "Olinmoqda…",
  "common.choose": "Tanlang",
  "common.empty": "Ma'lumot yo'q",
  "common.error": "Xatolik yuz berdi",
  "common.retry": "Qayta urinish",
  "common.reason": "Sabab",
  "common.required": "Bu maydon to'ldirilishi shart",
  "common.uzs": "so'm",
  "common.period": "Davr",
  "common.more": "Yana yuklash",
  "common.noAccess": "Bu bo'limga ruxsatingiz yo'q",

  // ---------------------------------------------------------------- client card
  "clients.card.profile": "Profil",
  "clients.card.phone": "Telefon",
  "clients.card.email": "Email",
  "clients.card.branch": "Filial",
  "clients.card.assignee": "Mas'ul",
  "clients.card.tags": "Teglar",
  "clients.card.note": "Izoh",
  "clients.card.deals": "Bitimlar",
  "clients.card.deals.empty": "Bitim yo'q",
  "clients.card.travelers": "Sayohatchilar",
  "clients.card.travelers.empty": "Sayohatchilar kiritilmagan",
  "clients.card.passport": "Pasport",
  "clients.card.lastActivity": "Oxirgi faollik",
  "clients.card.none": "—",

  // ---------------------------------------------------------------- settings
  "settings.title": "Sozlamalar",
  "settings.saveFailed": "Saqlab bo'lmadi. Qayta urinib ko'ring.",
  "settings.agency.title": "Agentlik profili",
  "settings.agency.hint": "Mijozlarga ko'rinadigan nom, manzil va telefon.",
  "settings.agency.name": "Agentlik nomi",
  "settings.agency.address": "Bosh ofis manzili",
  "settings.agency.phone": "Telefon",
  "settings.agency.timezone": "Vaqt zonasi",
  "settings.agency.timezoneHint": "Ish vaqti, SLA soati va «bugun» shu zonada hisoblanadi.",
  "settings.agency.logo": "Logotip",
  "settings.agency.logoHint": "PNG, JPEG yoki WebP, 2 MB gacha.",
  "settings.agency.logoChoose": "Logotip tanlash",
  "settings.agency.logoAlt": "Agentlik logotipi",
  "settings.agency.logoNone": "Logotip yuklanmagan",
  "settings.agency.ownerOnly": "Profilni faqat egasi o'zgartira oladi.",
  "settings.subtitle": "Agentlik konfiguratsiyasi",
  "settings.section.branches": "Filiallar",
  "settings.section.team": "Xodimlar va rollar",
  "settings.section.cashAccounts": "Kassalar",
  "settings.section.stages": "Bosqichlar",
  "settings.section.later": "keyingi bosqichda",

  "settings.branches.add": "+ Filial qo'shish",
  "settings.branches.name": "Nomi",
  "settings.branches.address": "Manzil",
  "settings.branches.phone": "Telefon",
  "settings.branches.status": "Holat",
  "settings.branches.empty": "Filial yo'q",
  "settings.branches.namePlaceholder": "Toshkent, Chilonzor",

  "settings.team.add": "+ Xodim qo'shish",
  "settings.team.name": "Ism",
  "settings.team.email": "Email",
  "settings.team.role": "Rol",
  "settings.team.branch": "Filial",
  "settings.team.status": "Holat",
  "settings.team.empty": "Xodim yo'q",
  "settings.team.invite": "Taklif qilish",
  "settings.team.inviteTitle": "Yangi xodim",
  "settings.team.linkTitle": "Parol o'rnatish havolasi",
  "settings.team.linkHint": "Bu havolani xodimga bevosita bering. U bir marta ishlaydi va hech qayerda saqlanmaydi.",
  "settings.team.copy": "Nusxalash",
  "settings.team.copied": "Nusxalandi",
  "settings.team.noBranch": "Filialsiz",

  "settings.margin.title": "Operatorlar marjani ko'radi",
  "settings.margin.hint": "O'chirilgan bo'lsa operator bitim va KPI'da faqat sotuv narxini ko'radi.",

  "settings.kassa.add": "+ Kassa qo'shish",
  "settings.kassa.name": "Nomi",
  "settings.kassa.currency": "Valyuta",
  "settings.kassa.kind": "Usul",
  "kassa.kind.cash": "Naqd",
  "kassa.kind.terminal": "Terminal",
  "kassa.kind.payme_click": "Payme / Click",
  "kassa.kind.bank_transfer": "Bank o'tkazma",
  "settings.kassa.opening": "Boshlang'ich qoldiq",
  "settings.kassa.status": "Holat",
  "settings.kassa.empty": "Kassa yo'q",
  "settings.kassa.openingHint": "Kapitan ishga tushgan kundagi qoldiq. Keyin balans shu yerdan hisoblanadi.",

  "settings.stages.add": "+ Bosqich qo'shish",
  "settings.stages.title": "Voronka bosqichlari",
  "settings.stages.empty": "Bosqich yo'q",
  "settings.stages.won": "Yutilgan",
  "settings.stages.lost": "Yo'qotilgan",
  "settings.stages.booked": "Bron qilingan",
  "settings.stages.up": "Yuqoriga",
  "settings.stages.down": "Pastga",
  "settings.stages.saveOrder": "Tartibni saqlash",

  "settings.matrix.title": "Rollar va huquqlar",
  "settings.matrix.hint": "Bu jadval kodda belgilangan qoidalardan avtomatik hosil qilinadi.",
  "settings.matrix.capability": "Huquq",

  "settings.cap.create_payments": "To'lov kiritish",
  "settings.cap.approve_payments": "To'lovni tasdiqlash",
  "settings.cap.view_kassa_balances": "Kassa balansini ko'rish",
  "settings.cap.manage_expenses": "Chiqimlarni boshqarish",
  "settings.cap.manage_cash_accounts": "Kassalarni sozlash",
  "settings.cap.view_reports": "Hisobotlarni ko'rish",
  "settings.cap.view_all_branches": "Barcha filiallarni ko'rish",
  "settings.cap.edit_crm_records": "Bitim va mijozlarni o'zgartirish",
  "settings.cap.override_client_discipline": "Intizomni qo'lda o'zgartirish",
  "settings.cap.manage_pipeline_stages": "Bosqichlarni sozlash",
  "settings.cap.manage_branches": "Filiallarni boshqarish",
  "settings.cap.manage_memberships": "Xodimlarni boshqarish",
  "settings.cap.manage_tenant_settings": "Sozlamalarni o'zgartirish",

  "settings.later.telegram": "Telegram akkauntlari",
  "settings.later.instagram": "Instagram",
  "settings.later.providers": "Provayderlar",
  "settings.later.sla": "SLA qoidalari",
  "settings.later.templates": "Shablonlar",
  "settings.templates.title": "Shartnoma shablonlari",
  "settings.templates.add": "+ Shablon qo'shish",
  "settings.templates.name": "Nomi",
  "settings.templates.body": "Matn",
  "settings.templates.bodyHint": "{example} kabi o'zgaruvchilar shartnoma tuzilganda to'ldiriladi.",
  "settings.templates.status": "Holat",
  "settings.templates.isActive": "Faol: mijozga shartnoma tuzishda ishlatiladi",
  "settings.templates.view": "Ko'rish",
  "settings.templates.edit": "Tahrirlash",
  "settings.templates.empty": "Shartnoma shabloni yo'q",
  "settings.templates.ownerOnly": "Shablonni faqat egasi o'zgartiradi. Siz uni faqat ko'rishingiz mumkin.",
  "settings.templates.saveFailed": "Shablonni saqlab bo'lmadi.",
  "settings.later.rules": "Qoidalar bazasi",
  "settings.later.balance": "Balans",

  "settings.active": "Faol",
  "settings.inactive": "O'chirilgan",
  "settings.deactivate": "O'chirish",
  "settings.activate": "Yoqish",
  "settings.save": "Saqlash",
  "settings.cancel": "Bekor qilish",

  // ---------------------------------------------------------------- password set
  "passwordSet.title": "Parol o'rnatish",
  "passwordSet.subtitle": "Hisobingizga kirish uchun yangi parol yarating",
  "passwordSet.password": "Yangi parol",
  "passwordSet.repeat": "Parolni takrorlang",
  "passwordSet.submit": "Saqlash",
  "passwordSet.saving": "Saqlanmoqda…",
  "passwordSet.done": "Parol o'rnatildi. Kirish sahifasiga o'tilmoqda…",
  "passwordSet.mismatch": "Parollar mos kelmadi",
  "passwordSet.invalid": "Havola yaroqsiz yoki muddati tugagan",
  "passwordSet.backToLogin": "Kirish sahifasiga qaytish",

  // ---------------------------------------------------------------- dashboard
  "home.title": "Bosh sahifa",
  "home.subtitle.operator": "Bugungi ish navbati va asosiy ko'rsatkichlar",
  "home.subtitle.branch_manager": "Filial holati va jamoa yuklamasi",
  "home.subtitle.moliyachi": "Kassa holati va tasdiq navbati",
  "home.subtitle.owner": "Barcha filiallar bo'yicha umumiy holat",

  "home.kpi.open_deals": "Ochiq bitimlar",
  "home.kpi.closed_this_month": "Bu oy yopilgan",
  "home.kpi.overdue_payments": "Kechikkan to'lovlar",
  "home.kpi.attention": "E'tibor talab qiladi",
  "home.kpi.today_income": "Bugun tushum",
  "home.kpi.pending_approval": "Tasdiq kutilmoqda",
  "home.kpi.month_income": "Bu oy daromad",
  "home.kpi.won_this_month": "Bu oy yopilgan bitimlar",

  "home.myDeals": "Mening ochiq bitimlarim",
  "home.myDeals.empty": "Ochiq bitim yo'q",
  "home.tasks": "Bugungi vazifalar",
  "home.tasks.empty": "Bugunga vazifa yo'q",
  "home.task.next_step": "Keyingi qadam",
  "home.task.expected_payment": "Kutilayotgan to'lov",
  "home.attention": "E'tibor talab qiladi",
  "home.attention.empty": "Hammasi joyida",
  "home.attention.stalled": "Keyingi qadam kechikdi",
  "home.attention.missing_cost": "Netto kiritilmagan",
  "home.workload": "Jamoa yuklamasi",
  "home.workload.empty": "Ochiq bitim yo'q",
  "home.workload.deals": "{count} bitim",
  "home.funnel": "Voronka bosqichlari",
  "home.funnel.empty": "Bosqichlar sozlanmagan",
  "home.kassa": "Kassa holati",
  "home.kassa.empty": "Kassa sozlanmagan",
  "home.kassa.noMovement": "harakat yo'q",
  "home.branches": "Filiallar taqqoslash",
  "home.branches.empty": "Filial yo'q",
  "home.branches.name": "Filial",
  "home.branches.openDeals": "Ochiq",
  "home.branches.wonDeals": "Yopilgan",
  "home.branches.collected": "Tushum (uzs)",
  "home.branches.margin": "Marja",
  "home.income": "Tushum-chiqim dinamikasi",
  "home.income.empty": "Ma'lumot yo'q",
  "home.income.in": "Tushum",
  "home.income.out": "Chiqim",
  "home.receivables": "Qarzdorlik",
  "home.receivables.empty": "Qarzdorlik yo'q",
  "home.margin": "Marja",
  "home.margin.empty": "Ma'lumot yo'q",
  "home.overdueBy": "{days} kun kechikdi",
  "home.dueToday": "Bugun",
  "home.noNextStep": "Keyingi qadam belgilanmagan",

  "common.notifications": "Bildirishnomalar",
  "common.markAllRead": "Hammasini o'qilgan deb belgilash",
  "common.noNotifications": "Xabarlar yo'q",
  "common.criticalLabel": "Muhim",
  "common.criticalCount": "{count} ta muhim xabar o'qilmagan",

  // ---------------------------------------------------------------- shell
  "nav.tasks": "Vazifalar",
  "nav.aiAgent": "AI agent",
  "nav.assistant": "Yordamchi",
  "nav.murojaatlar": "Murojaatlar",
  "nav.bronlar": "Bronlar",
  "nav.aiAssistant": "AI yordamchi",
  "nav.team": "Jamoa va filiallar",
  "nav.distribution": "Taqsimlash qoidalari",
  "nav.badgeCount": "{count} ta",
  "nav.automations": "Avtomatizatsiya",
  "nav.campaigns": "Kampaniyalar",
  "nav.documentRequirements": "Hujjat talablari",
  "nav.more": "Yana",
  "nav.soon": "Tez orada",
  "shell.collapse": "Menyuni yig'ish",
  "shell.expand": "Menyuni ochish",
  "shell.searchPlaceholder": "Mijoz, bitim, bron raqami, telefon",
  "shell.branch": "Filial",
  "shell.breadcrumbLabel": "Joylashuv",
  "shell.create.deal": "Bitim",
  "shell.create.client": "Mijoz",
  "shell.create.payment": "To'lov",
  "shell.create.expense": "Chiqim",

  // ---------------------------------------------------------------- 09 · Mijozlar (R6, R7)
  "clientList.subtitle": "{branch} · {count} mijoz",
  "clientList.allBranches": "Barcha filiallar",
  "clientList.export": "Excelga yuklash",
  "clientList.exportHint": "Har bir yuklash tarixga yoziladi",
  "clientList.exportFailed": "Faylni yuklab bo'lmadi",
  "clientList.new": "+ Yangi mijoz",
  "clientList.search": "Ism, telefon yoki pasport",
  "clientList.today": "Bugungi imkoniyatlar",
  "clientList.today.returned": "Safardan qaytdi",
  "clientList.today.returnedHint": "fikr so'rash",
  "clientList.today.birthday": "Tug'ilgan kun",
  "clientList.today.birthdayHint": "shu hafta",
  "clientList.today.passport": "Pasport tugayapti",
  "clientList.today.passportHint": "6 oy ichida",
  "clientList.today.yearAgo": "Bir yil oldin safar qilgan",
  "clientList.today.yearAgoHint": "qayta taklif",
  "clientList.today.clear": "Imkoniyat filtrini olib tashlash",
  "clientList.filter.branch": "Filial",
  "clientList.filter.owner": "Mas'ul",
  "clientList.filter.source": "Manba",
  "clientList.filter.destination": "Yo'nalish",
  "clientList.filter.any": "Hammasi",
  "clientList.filter.reset": "Filtrlarni tozalash",
  "clientList.col.select": "Tanlash",
  "clientList.col.client": "Mijoz",
  "clientList.col.group": "Guruh",
  "clientList.col.trips": "Safarlar",
  "clientList.col.total": "Jami summa",
  "clientList.col.lastTrip": "Oxirgi safar",
  "clientList.col.next": "Keyingi imkoniyat",
  "clientList.col.source": "Manba",
  "clientList.col.owner": "Mas'ul",
  "clientList.selectAll": "Sahifadagi barcha mijozlarni tanlash",
  "clientList.selectRow": "{name}ni tanlash",
  "clientList.referredBy": "Tavsiya: {name}",
  "clientList.source.instagramComment": "Instagram izoh",
  "clientList.source.website": "Sayt",
  "clientList.source.import": "Import",
  "clientList.bulk.selected": "{count} ta tanlandi",
  "clientList.bulk.clear": "Tanlovni bekor qilish",
  "clientList.bulk.telegram": "Telegram xabar yuborish",
  "clientList.bulk.owner": "Mas'ulni almashtirish",
  "clientList.bulk.tag": "Teg qo'shish",
  "clientList.bulk.consentSplit": "{total} tadan {eligible} tasiga yuboriladi — {skipped} tasi rozilik bermagan",
  "clientList.bulk.consentAll": "{eligible} ta yuboriladi — hammasi rozilik bergan",
  "clientList.bulk.noneEligible": "Tanlanganlarning hech biri aksiya olishga rozilik bermagan",
  "clientList.bulk.text": "Xabar matni",
  "clientList.bulk.send": "Yuborish",
  "clientList.bulk.queued": "Xabar navbatga qo'yildi",
  "clientList.bulk.progress": "Yuborildi: {sent} / {eligible}",
  "clientList.bulk.progressFailed": "Xato: {failed}",
  "clientList.bulk.done": "Yuborish tugadi",
  "clientList.bulk.newOwner": "Yangi mas'ul",
  "clientList.bulk.noOwner": "Mas'ulsiz",
  "clientList.bulk.ownerSaved": "{count} ta mijozning mas'uli almashtirildi",
  "clientList.bulk.tagName": "Teg",
  "clientList.bulk.tagSaved": "{count} ta mijozga teg qo'shildi",
  "clientList.bulk.failed": "Bajarib bo'lmadi",
  "clientList.bulk.cancel": "Bekor qilish",
  "clientList.bulk.save": "Saqlash",
  "clientNew.breadcrumb": "Mijozlar",
  "clientNew.title": "Yangi mijoz",
  "clientNew.quick.title": "Tez kiritish",
  "clientNew.quick.placeholder": "Masalan: Malika Yusupova, +998 90 111 22 33, Dubay, 10–17 dekabr, 2 kattalar va 7 yoshli bola, byudjet 3000 dollar",
  "clientNew.quick.label": "Mijoz aytganlari",
  "clientNew.quick.fill": "Maydonlarni to'ldirish",
  "clientNew.quick.filled": "{count} ta maydon to'ldirildi — tekshirib chiqing",
  "clientNew.quick.nothing": "Matndan maydon topilmadi",
  "clientNew.quick.failed": "Maydonlarni to'ldirib bo'lmadi",
  "clientNew.ai": "AI",
  "clientNew.aiHint": "AI to'ldirdi — tekshiring",
  "clientNew.source.title": "Mijoz qayerdan keldi?",
  "clientNew.source.required": "Manbani tanlang",
  "clientNew.source.walkIn": "Ofisga keldi",
  "clientNew.source.phone": "Telefon qo'ng'irog'i",
  "clientNew.source.instagramAd": "Instagram reklama",
  "clientNew.source.instagram": "Instagram",
  "clientNew.source.telegram": "Telegram",
  "clientNew.source.referral": "Tavsiya",
  "clientNew.source.corporate": "Korporativ",
  "clientNew.referrer": "Kim tavsiya qildi",
  "clientNew.referrerSearch": "Mijozni qidirish",
  "clientNew.referrerPlaceholder": "Bazadan mijozni tanlang",
  "clientNew.referrerEmpty": "Mijoz topilmadi",
  "clientNew.contact.title": "Aloqa ma'lumotlari",
  "clientNew.contact.name": "Ism, familiya",
  "clientNew.contact.phone": "Telefon",
  "clientNew.contact.phoneNew": "Yangi raqam — bazada takrori yo'q",
  "clientNew.contact.phoneExists": "Bu raqam bazada bor: {name}",
  "clientNew.contact.phoneHidden": "Bu raqam bazada boshqa xodimning mijozida bor",
  "clientNew.contact.openExisting": "Mavjud mijozni ochish",
  "clientNew.contact.handle": "Telegram yoki Instagram",
  "clientNew.contact.handleKind": "Tarmoq",
  "clientNew.contact.email": "Email",
  "clientNew.contact.birthDate": "Tug'ilgan sana",
  "clientNew.contact.language": "Muloqot tili",
  "clientNew.contact.languageAny": "Tanlanmagan",
  "clientNew.language.uzLatn": "O'zbekcha (lotin)",
  "clientNew.language.uzCyrl": "O'zbekcha (kirill)",
  "clientNew.language.ru": "Ruscha",
  "clientNew.language.en": "Inglizcha",
  "clientNew.need.title": "Nima kerak?",
  "clientNew.service.tour": "Tur",
  "clientNew.service.visa": "Viza",
  "clientNew.service.avia": "Aviachipta",
  "clientNew.service.business": "Biznes safar",
  "clientNew.need.destination": "Yo'nalish",
  "clientNew.need.destinationSearch": "Yo'nalishni qidirish",
  "clientNew.need.destinationPlaceholder": "Katalogdan tanlang",
  "clientNew.need.destinationEmpty": "Yo'nalish topilmadi",
  "clientNew.need.destinationText": "Yoki mijoz aytganidek yozing",
  "clientNew.need.departure": "Uchish shahri",
  "clientNew.need.departureAny": "Tanlanmagan",
  "clientNew.need.dateFrom": "Ketish sanasi",
  "clientNew.need.dateTo": "Qaytish sanasi",
  "clientNew.need.flexible": "Sanalar moslashuvchan (±3 kun)",
  "clientNew.need.adults": "Kattalar",
  "clientNew.need.children": "Bolalar",
  "clientNew.need.childAge": "{n}-bola yoshi",
  "clientNew.need.budget": "Byudjet",
  "clientNew.need.currency": "Valyuta",
  "clientNew.need.hotel": "Mehmonxona talabi",
  "clientNew.need.hotelAny": "Farqi yo'q",
  "clientNew.need.hotelStars": "{n} yulduz",
  "clientNew.consent": "Aksiya va yangiliklar olishga rozi (Telegram orqali)",
  "clientNew.cancel": "Bekor qilish",
  "clientNew.saveClient": "Faqat mijozni saqlash",
  "clientNew.saveBoth": "Mijoz va bitim yaratish",
  "clientNew.savedClient": "Mijoz saqlandi",
  "clientNew.savedBoth": "Mijoz va bitim yaratildi",
  "clientNew.saveFailed": "Saqlanmadi. Maydonlarni tekshirib, qayta urinib ko'ring.",
  "clientNew.duplicate": "Bu raqam bazada bor",
  "clientNew.guide.title": "Suhbat yo'riqnomasi",
  "clientNew.guide.progress": "{answered} / {total}",
  "clientNew.guide.failed": "Yo'riqnomani yuklab bo'lmadi",
  "clientNew.guide.done": "Javob olindi",
  "clientNew.tours.title": "Mos turlar",
  "clientNew.tours.needDestination": "Yo'nalishni katalogdan tanlang — mos turlar shu yerda chiqadi",
  "clientNew.tours.found": "{count} ta variant topildi, eng arzoni {price}",
  "clientNew.tours.foundNoPrice": "{count} ta variant topildi",
  "clientNew.tours.none": "Saqlangan takliflar orasida mos variant yo'q",
  "clientNew.tours.failed": "Mos turlarni yuklab bo'lmadi",
  "clientNew.tours.open": "Variantlarni ko'rish",
  "shell.menu.profile": "Profil",
  "shell.menu.switchAgency": "Agentlik tanlash",
  "agency.choose.title": "Agentlikni tanlang",
  "agency.choose.hint": "Siz bir nechta agentlikda ishlaysiz. Davom etish uchun birini tanlang.",
  "shell.menu.platform": "Platforma paneli",
  "shell.menu.userLabel": "Hisob menyusi",
  "shell.palette.title": "Qidirish va o'tish",
  "shell.palette.placeholder": "Bo'lim, bitim yoki mijoz…",
  "shell.palette.empty": "Hech narsa topilmadi",
  "shell.palette.navigate": "Bo'limlar",
  "shell.palette.actions": "Amallar",
  "shell.mobileMore": "Boshqa bo'limlar",
  "shell.close": "Yopish",

  // ---------------------------------------------------------------- work surfaces
  "work.sla.label": "Javob kutish",
  "work.sla.escalated": "Eskalatsiya",
  "work.ai": "AI yozgan",
  "work.aiDrafted": "AI tayyorlagan",
  "work.accept": "Yuborish",
  "work.discard": "Rad etish",
  "work.approve": "Tasdiqlash",
  "work.reject": "Rad etish",
  "work.confirmed": "Tasdiqlangan",
  "work.aiFilled": "AI to'ldirgan",
  "work.hot": "Issiq",
  "work.providerOk": "Ulangan",
  "work.providerLoading": "Qidirilmoqda",
  "work.providerError": "Javob bermadi",
  "work.providerEmpty": "Natija yo'q",
  "state.noPermission": "Bu bo'limga ruxsatingiz yo'q",
  "state.emptyList": "Hozircha yozuv yo'q",
  "state.emptyFiltered": "Filtr bo'yicha natija yo'q",
  "state.reset": "Filtrni tozalash",
  "state.errorRetry": "Ma'lumotni yuklab bo'lmadi",

  // ---------------------------------------------------------------- platform / kit
  "kit.title": "UI kit",
  "kit.groups.primitives": "Asosiy elementlar",
  "kit.groups.forms": "Formalar",
  "kit.groups.data": "Ma'lumot va jadval",
  "kit.groups.work": "Ish yuzalari",
  "kit.groups.charts": "Grafiklar",
  "kit.groups.states": "Holatlar",
  "kit.groups.shell": "Qobiq",
  "auth.platformOnly": "Bu bo'lim faqat platforma administratorlari uchun",
  "auth.unreachable":
    "Server bilan aloqa yo'q. Internetni tekshiring yoki birozdan keyin qayta urinib ko'ring.",

  // ---------------------------------------------------------------- contracts (Shartnoma)
  "deals.tab.contracts": "Shartnoma",
  "contract.noAccess": "Shartnomalar bilan ishlash huquqingiz yo'q.",
  "contract.empty": "Shartnomalar yo'q",
  "contract.create": "Shartnoma yaratish",
  "contract.template": "Shablon",
  "contract.templateEmpty": "Faol shablon yo'q",
  "contract.state.draft": "Qoralama",
  "contract.state.sent": "Yuborildi",
  "contract.state.signed": "Imzolandi",
  "contract.state.void": "Bekor qilingan",
  "contract.version": "v{version}",
  "contract.preview": "PDF ko'rish",
  "contract.edit": "Matnni tahrirlash",
  "contract.bodyLabel": "Shartnoma matni",
  "contract.send": "Mijozga yuborish",
  "contract.sendTitle": "Shartnomani yuborishni tasdiqlang",
  "contract.sendHint":
    "Yuborilgandan keyin matn o'zgarmaydi. Tizim xabar yubormaydi: havolani o'zingiz mijozga yuborasiz.",
  "contract.copyLink": "Havolani nusxalash",
  "contract.linkCopied": "Havola nusxalandi",
  "contract.signedCopy": "Imzolangan nusxa",
  "contract.void": "Bekor qilish",
  "contract.voidTitle": "Shartnomani bekor qilish",
  "contract.voidHint": "Sabab yoziladi. Bekor qilingan shartnoma tarixda qoladi.",
  "contract.voidConfirm": "Shartnomani bekor qilish",
  "contract.signedNoVoid": "Imzolangan shartnoma bekor qilinmaydi",
  "contract.created": "Qoralama yaratildi",
  "contract.saved": "Matn saqlandi",
  "contract.sent": "Shartnoma yuborildi",
  "contract.voided": "Shartnoma bekor qilindi",
  "contract.sentAt": "Yuborilgan: {date}",
  "contract.signedAt": "Imzolangan: {date}",
  "contract.expiresAt": "Havola muddati: {date}",
  "contract.frozen": "Matn muzlatilgan: tahrirlab bo'lmaydi.",
  "contract.popupBlocked": "Brauzer yangi oynani ochishga ruxsat bermadi.",
  "contract.copyFailed": "Havolani nusxalab bo'lmadi.",

  // ---------------------------------------------------------------- payment links
  "paymentLink.action.create": "To'lov havolasi",
  "paymentLink.title": "To'lov havolasi",
  "paymentLink.gateway": "To'lov tizimi",
  "paymentLink.gateway.payme": "Payme",
  "paymentLink.gateway.click": "Click",
  "paymentLink.amount": "Summa (so'm)",
  "paymentLink.fullBalance": "Qoldiqni to'liq",
  "paymentLink.freeAmount": "Ixtiyoriy summa",
  "paymentLink.remaining": "Qoldiq: {amount}",
  "paymentLink.overRemaining": "Summa qoldiqdan katta. Eng ko'pi: {amount}",
  "paymentLink.rateMissing": "Kurs topilmadi: summa serverda tekshiriladi",
  "paymentLink.invalidAmount": "Summani to'g'ri kiriting",
  "paymentLink.submit": "Havola yaratish",
  "paymentLink.created": "Havola tayyor",
  "paymentLink.createdHint": "Havolani mijozga yuboring. U to'lovni o'zi amalga oshiradi.",
  "paymentLink.copy": "Nusxalash",
  "paymentLink.copied": "Havola nusxalandi",
  "paymentLink.instalment": "Qaysi bo'lakka",
  "paymentLink.noInstalment": "Bo'lakka bog'lamaslik",
  "paymentLink.instalmentAmount": "{amount} · {date}",
  "paymentLink.column.client": "Mijoz",
  "paymentLink.column.amount": "Summa",
  "paymentLink.column.gateway": "Tizim",
  "paymentLink.column.state": "Holat",
  "paymentLink.column.expires": "Muddat",
  "paymentLink.column.created": "Yaratildi",
  "paymentLink.empty": "To'lov havolalari yo'q",
  "paymentLink.cancelTitle": "To'lov havolasini bekor qilish",
  "paymentLink.cancelConfirm": "Havolani bekor qilish",
  "paymentLink.cancelled": "Havola bekor qilindi",
  "paymentLink.state.sent": "Yuborildi",
  "paymentLink.state.opened": "Ochildi",
  "paymentLink.state.paid": "To'landi",
  "paymentLink.state.expired": "Muddati o'tdi",
  "paymentLink.state.cancelled": "Bekor qilindi",
  "paymentLink.next": "Keyingi",
  "paymentLink.previous": "Oldingi",
  "finance.tab.paymentLinks": "To'lov havolalari",

  // ---------------------------------------------------------------- public signing (/s/:token)
  "sign.agency": "{name}",
  "sign.step.read": "Matnni o'qing",
  "sign.step.code": "SMS kod",
  "sign.step.enterCode": "Kodni kiriting",
  "sign.step.signature": "Imzo",
  "sign.step.confirm": "Tasdiqlash",
  "sign.readHint": "Shartnoma matnini oxirigacha o'qing.",
  "sign.pdfPreview": "PDF ko'rish",
  "sign.sendCode": "SMS kod yuborish",
  "sign.codeSentTo": "Kod {phone} raqamiga yuborildi.",
  "sign.phoneHint": "Raqam: {phone}",
  "sign.codeInput": "6 raqamli kod",
  "sign.codeNeeded": "6 ta raqam kiriting.",
  "sign.resendCode": "Kodni qayta yuborish",
  "sign.signatureHint": "Imzoni quyidagi maydonga chizing.",
  "sign.signatureNeeded": "Avval imzo chizing.",
  "sign.clear": "Tozalash",
  "sign.next": "Keyingi",
  "sign.back": "Orqaga",
  "sign.submit": "Imzolash",
  "sign.submitting": "Imzolanmoqda…",
  "sign.signed": "Imzolandi",
  "sign.signedAt": "Imzolangan vaqt: {date}",
  "sign.download": "Imzolangan nusxani yuklab olish",
  "sign.confirmHint": "Imzolash orqali shartnoma matniga rozilik bildirasiz.",
  "sign.canvasLabel": "Imzo maydoni",
  "sign.notFound": "Hujjat topilmadi yoki muddati o'tgan.",

  // ---------------------------------------------------------------- public payment (/pay/:token)
  "pay.title": "To'lov",
  "pay.amount": "Summa",
  "pay.submit": "To'lash",
  "pay.status.active": "To'lovga tayyor",
  "pay.status.paid": "To'langan",
  "pay.status.expired": "Muddati o'tgan",
  "pay.status.unavailable": "Bu havola orqali hozir to'lov qilib bo'lmaydi.",
  "pay.expiresAt": "Amal qilish muddati: {date}",
  "pay.notFound": "Havola topilmadi yoki muddati o'tgan.",

  // ---------------------------------------------------------------- avia
  "avia.title": "Aviabiletlar",
  "avia.notice": "Narx provayderning o'z valyutasida ko'rsatiladi, so'mga o'girilmaydi.",
  "avia.field.origin": "Qayerdan",
  "avia.field.destination": "Qayerga",
  "avia.field.departMonth": "Ketish oyi",
  "avia.field.returnMonth": "Qaytish oyi (ixtiyoriy)",
  "avia.field.direct": "Faqat to'g'ridan-to'g'ri",
  "avia.hint.origin": "Aeroportning 3 harfli kodi: TAS — Toshkent, SKD — Samarqand.",
  "avia.hint.destination": "Masalan IST — Istanbul, DXB — Dubay, AYT — Antalya.",
  "avia.hint.departMonth": "Shu oy ichidagi eng arzon chiptalar ko'rsatiladi.",
  "avia.hint.returnMonth": "Bo'sh qoldirilsa, faqat bir tomonga.",
  "avia.submit": "Qidirish",
  "avia.error.iata": "3 harfli IATA kodi kiriting, masalan TAS",
  "avia.error.sameRoute": "Qayerdan va qayerga bir xil bo'lmasin",
  "avia.error.month": "YYYY-OY ko'rinishida kiriting",
  "avia.error.returnBeforeDepart": "Qaytish oyi ketish oyidan oldin bo'lmasin",
  "avia.notConfigured.title": "Aviabiletlar ulanmagan",
  "avia.error.title": "Aviabiletlar yuklanmadi",
  "avia.empty": "Bu yo'nalishda chiptalar topilmadi",
  "avia.empty.action": "Qidiruvni o'zgartirish",
  "avia.col.flight": "Reys",
  "avia.col.route": "Yo'nalish",
  "avia.col.departure": "Ketish",
  "avia.col.return": "Qaytish",
  "avia.col.stops": "To'xtash",
  "avia.col.duration": "Vaqt",
  "avia.col.price": "Narx",
  "avia.stops.direct": "To'g'ridan-to'g'ri",
  "avia.stops.count": "{count} ta to'xtash",
  "avia.duration": "{hours}s {minutes}d",
  "avia.open": "Chiptani ko'rish",
  "avia.nextPage": "Keyingi sahifa",
  "avia.previousPage": "Oldingi sahifa",
  "avia.forbidden.title": "Qidiruv vaqtincha to'xtatilgan",

  // ---------------------------------------------------------------- notifications (§19)
  "profile.notifications.title": "Bildirishnomalar",
  "profile.notifications.hint":
    "Har bir bildirishnomani qaysi kanal orqali olishni tanlang. Muhim bildirishnomalarni o'chirib bo'lmaydi.",
  "profile.notifications.locked": "Muhim: doim yoqilgan",
  "profile.notifications.soon": "Tez orada",
  "profile.notifications.saveFailed": "Saqlab bo'lmadi. Qayta urinib ko'ring.",
  "profile.notifications.empty": "Bildirishnomalar ro'yxati bo'sh",

  // ---------------------------------------------------------------- audit journal (§22)
  "settings.section.audit": "Audit jurnali",
  "audit.title": "Audit jurnali",
  "audit.subtitle": "Kim, qachon, nimani o'zgartirdi yoki ko'rdi. Yozuvlar o'zgartirilmaydi.",
  "audit.filter.action": "Hodisa kodi",
  "audit.filter.group": "Guruh (masalan, payment)",
  "audit.filter.actor": "Kim (turi)",
  "audit.filter.from": "Sanadan",
  "audit.filter.to": "Sanagacha",
  "audit.filter.severity": "Muhimlik",
  "audit.filter.all": "Hammasi",
  "audit.column.at": "Vaqt",
  "audit.column.actor": "Kim",
  "audit.column.action": "Hodisa",
  "audit.column.object": "Obyekt",
  "audit.column.severity": "Muhimlik",
  "audit.empty": "Hodisalar yo'q",
  "audit.nextPage": "Keyingi sahifa",
  "audit.previousPage": "Oldingi sahifa",

  // ---------------------------------------------------------------- brief 11: section layout
  "home.kpi.group": "Asosiy ko'rsatkichlar",
  "home.kassa.group": "Kassalar",
  "home.kassa.today": "Bugun",
  "finance.today.pendingCount": "{count} ta",
  "reports.fact.group": "Asosiy ko'rsatkichlar",
  "reports.fact.howComputed": "Qanday hisoblandi",
  "reports.fact.howComputedFor": "Qanday hisoblandi: {label}",
  // ---------------------------------------------------------------- settings sections (spec §11, §2)
  "settings.nav.agency": "Agentlik ma'lumotlari",
  "settings.nav.team": "Jamoa va filiallar",
  "settings.nav.distribution": "Taqsimlash qoidalari",
  "settings.nav.pricing": "Narx va ustamalar",
  "settings.nav.operators": "Turoperatorlar ulanishi",
  "settings.nav.catalog": "Katalogni moslashtirish",
  "settings.nav.documents": "Hujjat talablari",
  "settings.placeholder": "Bu bo'lim tez orada tayyor bo'ladi.",
  "settings.distribution.rule": "Yangi murojaatlar faqat «Ishda» holatidagi operatorlarga taqsimlanadi. Tanaffusdagi yoki «Ishda emas» holatidagi xodimga yangi suhbat berilmaydi.",
  "settings.layout.label": "Sozlamalar bo'limlari",

  // ---------------------------------------------------------------- pricing (spec §11.2)
  "pricing.title": "Narx va ustamalar",
  "pricing.minMargin": "Minimal marja, %",
  "pricing.minMarginHelp": "Undan past chegirmalar Egasining tasdig'iga tushadi.",
  "pricing.managersApprove": "Filial menejeri ham chegirmani tasdiqlay oladi",
  "pricing.operatorsSeeMargin": "Operatorlar netto va marjani ko'radi",
  "pricing.operatorsSeeMarginOn": "Yoqilgan: operator bitimda tannarx va marjani ko'radi.",
  "pricing.operatorsSeeMarginOff": "O'chirilgan: operator faqat brutto narxni ko'radi.",
  "pricing.markupTitle": "Xizmat turlari bo'yicha ustama",
  "pricing.markupHelp": "Tur qoidasi topilmasa, shu foiz qo'shiladi.",
  "pricing.markupTour": "Tur, %",
  "pricing.markupHotel": "Faqat mehmonxona, %",
  "pricing.markupPackage": "O'z paketi, %",
  "pricing.save": "Saqlash",
  "pricing.saved": "Saqlandi",

  // ---------------------------------------------------------------- approvals (spec §1, §5; D9.11)
  "approvals.queue.title": "Sizning qaroringiz kerak",
  "approvals.queue.empty": "Hozir tasdiq kutilayotgan so'rov yo'q",
  "approvals.queue.error": "So'rovlarni yuklab bo'lmadi",
  "approvals.discount.title": "Chegirma so'rovi",
  "approvals.discount.change": "{from} → {to}",
  "approvals.margin.badge": "Marja {margin}% — minimal {min}%",
  "approvals.reassign.title": "Suhbatni qayta biriktirish",
  "approvals.requestedBy": "{name} so'radi",
  "approvals.approve": "Tasdiqlash",
  "approvals.reject": "Rad etish",
  "approvals.rejectReason": "Rad etish sababi",
  "approvals.rejectConfirm": "Rad etishni tasdiqlash",
  "approvals.cancel": "Bekor qilish",
  "approvals.decided": "Qaror qabul qilindi",
  "auth.twoFactor.title": "Telegram orqali tasdiqlang",
  "auth.twoFactor.body": "Telegram botga xabar yubordik. «Tasdiqlash» tugmasini bosing — sahifa o'zi ochiladi.",
  "auth.twoFactor.cancel": "Bekor qilish",
  "auth.twoFactor.denied": "Kirish Telegram orqali rad etildi. Parolingizni almashtiring.",
  "auth.twoFactor.expired": "Tasdiqlash muddati o'tdi. Qayta kiring.",
  "status.working": "Ishda",
  "status.break": "Tanaffus",
  "status.off": "Ishda emas",
  "status.note": "«Ishda» holatida yangi murojaatlar sizga yuboriladi.",
  "status.label": "Holat",
  "shell.menu.week": "Bu hafta: {count} sotuv · Hisobotim →",
  "shell.menu.notifications": "Bildirishnomalar",
  "shell.menu.theme": "Mavzu",
  "shell.menu.language": "Til",
  "shell.menu.shortcuts": "Klaviatura yorliqlari",
  "shell.menu.help": "Yordam va qo'llanma",
  "shell.menu.agencySettings": "Agentlik sozlamalari",
  "shell.menu.profileSettings": "Profil sozlamalari",
  "shell.shortcuts.title": "Klaviatura yorliqlari",
  "shell.shortcuts.palette": "Qidirish va o'tish",
  "shell.shortcuts.help": "Shu ro'yxat",
  "shell.help.body": "Qo'llanma tayyorlanmoqda. Savollar bo'lsa, agentlik egasiga yoki Kapitan qo'llab-quvvatlash xizmatiga yozing.",
  "theme.light": "Yorug'",
  "theme.dark": "Qorong'i",
  "theme.system": "Qurilmaga qarab",
  "language.uz": "O'zbekcha",
  "language.ru": "Ruscha",
  "profile.title": "Profil",
  "profile.sections": "Profil bo'limlari",
  "profile.section.personal": "Shaxsiy ma'lumotlar",
  "profile.section.schedule": "Ish holati va jadvali",
  "profile.section.appearance": "Ko'rinish va til",
  "profile.section.notifications": "Bildirishnomalar",
  "profile.section.signature": "Xabar imzosi",
  "profile.section.security": "Xavfsizlik",
  "profile.fullName": "Ism va familiya",
  "profile.displayName": "Mijozlarga ko'rinadigan ism",
  "profile.phone": "Telefon",
  "profile.email": "Email",
  "profile.telegram": "Telegram",
  "profile.telegramNone": "Ulanmagan",
  "profile.role": "Rol",
  "profile.branch": "Filial",
  "profile.hireDate": "Ishga kirgan sana",
  "profile.ownerOnly": "Faqat egasi o'zgartiradi",
  "profile.photo": "Rasm",
  "profile.photoUpload": "Rasm yuklash",
  "profile.photoRemove": "Rasmni o'chirish",
  "profile.saved": "Saqlandi",
  "profile.schedule.days": "Ish kunlari",
  "profile.schedule.from": "Boshlanish",
  "profile.schedule.to": "Tugash",
  "profile.schedule.autoOff": "Ish vaqti tugaganda avtomatik «Ishda emas»",
  "profile.schedule.day0": "Du",
  "profile.schedule.day1": "Se",
  "profile.schedule.day2": "Ch",
  "profile.schedule.day3": "Pa",
  "profile.schedule.day4": "Ju",
  "profile.schedule.day5": "Sh",
  "profile.schedule.day6": "Ya",
  "profile.leave.title": "Ta'til va kasallik",
  "profile.leave.hint": "Menejer tasdiqlagandan keyin kuchga kiradi.",
  "profile.leave.kind": "Turi",
  "profile.leave.kindLeave": "Ta'til",
  "profile.leave.kindSick": "Kasallik",
  "profile.leave.from": "Sanadan",
  "profile.leave.to": "Sanagacha",
  "profile.leave.handover": "Mijozlarim kimga o'tadi",
  "profile.leave.note": "Izoh",
  "profile.leave.submit": "Menejerga yuborish",
  "profile.leave.cancel": "Bekor qilish",
  "profile.leave.empty": "So'rovlar yo'q",
  "profile.leave.status.pending": "Kutilmoqda",
  "profile.leave.status.approved": "Tasdiqlandi",
  "profile.leave.status.rejected": "Rad etildi",
  "profile.leave.status.cancelled": "Bekor qilindi",
  "profile.appearance.theme": "Mavzu",
  "profile.appearance.language": "Interfeys tili",
  "profile.appearance.currency": "Valyuta ko'rinishi",
  "profile.appearance.currencySymbol": "Belgi ($, so'm)",
  "profile.appearance.currencyCode": "Kod (USD, UZS)",
  "profile.quiet.title": "Jim rejim",
  "profile.quiet.hint": "Bu vaqtda faqat tizimdagi qo'ng'iroqcha yangilanadi. Muhim xabarlar baribir keladi.",
  "profile.quiet.enabled": "Jim rejimni yoqish",
  "profile.quiet.from": "Dan",
  "profile.quiet.to": "Gacha",
  "profile.connectBot": "Telegram botni ulash",
  "profile.signature.label": "Xabar imzosi",
  "profile.signature.hint": "Siz yuborgan xabarlar oxiriga qo'shiladi. AI tayyorlagan matnlarga ham qo'shiladi.",
  "profile.signature.preview": "Ko'rinishi",
  "profile.security.sessions": "Faol seanslar",
  "profile.security.thisDevice": "Shu qurilma",
  "profile.security.lastSeen": "Oxirgi faollik: {when}",
  "profile.security.revoke": "Chiqarish",
  "profile.security.revokeOthers": "Boshqa barcha qurilmalardan chiqish",
  "profile.security.revoked": "{count} ta qurilmadan chiqildi",
  "profile.security.twoFactor": "Ikki bosqichli kirish (Telegram)",
  "profile.security.twoFactorHint": "Paroldan keyin Telegram botda «Tasdiqlash» tugmasini bosasiz.",
  "profile.security.twoFactorNeedsTelegram": "Avval Telegram akkauntingizni ulang.",
  "profile.security.unknownDevice": "Noma'lum qurilma",
  "team.title": "Jamoa holati",
  "team.empty": "Xodimlar yo'q",
  "team.col.name": "Xodim",
  "team.col.status": "Holat",
  "team.col.schedule": "Ish jadvali",
  "team.col.leave": "Ta'til",
  "team.noSchedule": "Jadval yo'q",
  "team.leaveBadge": "Ta'tilda · {until}gacha · mijozlari {name}da",
  "team.leaveUpcoming": "Ta'til: {from} – {until}",
  "ai.tabs.label": "AI yordamchi bo'limlari",
  "ai.tabs.agent": "AI agent",
  "ai.tabs.automations": "Avtomatizatsiya",
  "ai.tabs.campaigns": "Kampaniyalar",

  // ---------------------------------------------------------------- home (09 §3, §4)
  "home09.unknownClient": "Noma'lum mijoz",
  "home09.duration.minutes": "{minutes} daqiqa",
  "home09.duration.hours": "{hours} soat",
  "home09.duration.hoursMinutes": "{hours} soat {minutes} daqiqa",
  "home09.summary.manager.calm": "Kutilayotgan qaror va javobsiz murojaat yo'q.",
  "home09.action.remind": "Eslatma yuborish",
  "home09.action.open": "Ochish",
  "home09.tip.later": "Keyinroq",
  "home09.tip.year_ago_trip": "{name} bir yil oldin shu paytda sayohat qilgan ({destination}). Yangi mavsum uchun taklif yuborish vaqti.",
  "home09.tip.returned_from_trip": "{name} sayohatdan qaytdi ({destination}). Taassurotlarini so'rab, keyingi sayohatni taklif qiling.",
  "home09.tip.generic": "{name} uchun yangi taklif vaqti keldi ({destination}).",
  "home09.tip.noDestination": "yo'nalish ko'rsatilmagan",
  "home09.near.title": "Sotuvga yaqin",
  "home09.near.empty": "Sotuvga yaqin bitim yo'q",
  "home09.filters.branch": "Filial",
  "home09.filters.period": "Davr",
  "home09.filters.week": "Bu hafta",
  "home09.filters.month": "Oy",
  "home09.delta.points": "p.p.",
  "home09.kpi.label": "Asosiy ko'rsatkichlar",
  "home09.funnel.empty": "Bu davrda murojaat yo'q",
  "home09.funnel.insufficient": "Xulosa uchun bosqichda kamida {minimum} ta murojaat kerak.",
  "home09.directions.title": "Yo'nalishlar bo'yicha tushum",
  "home09.directions.empty": "Bu davrda tushum yo'q",

  // ------------------------------------- 09: tur qidiruvi, bronlar, katalog
  "tq.title": "Tur qidiruvi",
  "tq.tab.tours": "Turlar",
  "tq.tab.hotels": "Faqat mehmonxona",
  "tq.tab.hot": "Qaynoq turlar",
  "tq.tab.avia": "Aviabiletlar",
  "tq.tab.packages": "O'z paketlarimiz",
  "tq.tabsLabel": "Qidiruv turi",
  "tq.selectionButton": "Tanlov · {count}",
  "tq.history": "Qidiruv tarixi",
  "tq.historyEmpty": "Hali qidiruv o'tkazilmagan.",
  "tq.clientMode": "Mijoz uchun: {name} · Bitim №{number}",
  "tq.clientModeNoDeal": "Mijoz uchun: {name}",
  "tq.clientModeExit": "Mijoz rejimidan chiqish",
  "tq.addToSelection": "+ Tanlov",
  "tq.addToSelectionLong": "+ Tanlovga",
  "tq.addedToSelection": "Tanlovga qo'shildi",
  "tq.selectionNeedsOwner": "Tanlov bitim yoki mijozga yoziladi. Avval mijoz rejimini oching.",
  "tq.book": "Bron ↗",
  "tq.bookTooltip": "Operator saytida ochiladi va bitimga bog'lanadi",
  "tq.bookLinked": "Bitim №{number} ga bog'landi",
  "tq.bookNoLink": "Bitimga bog'landi. Operator havolasi yo'q.",
  "tq.filters": "Filtrlar",
  "tq.filtersReset": "Tozalash",
  "tq.noFilterMatch": "Filtr bo'yicha natija yo'q.",
  "tq.loadFailed": "Natijalarni yuklab bo'lmadi.",
  "tq.find": "Topish",
  "tq.tours.aiLine": "Erkin matn: Misr, noyabr boshida, 2 katta + bola 7 yosh, 1 500 $ gacha",
  "tq.tours.aiApply": "Maydonlarga",
  "tq.tours.aiUnresolved": "Katalogda topilmadi: {words}. Qo'lda tanlang.",
  "tq.tours.departFlex": "Uchish (±{days} kun)",
  "tq.tours.from": "Qayerdan",
  "tq.tours.to": "Qayerga",
  "tq.tours.toPlaceholder": "Davlatni tanlang",
  "tq.tours.depart": "Uchish (±2 kun)",
  "tq.tours.flex": "±2 kun",
  "tq.tours.duration": "Davomiyligi",
  "tq.tours.nights": "{from}–{to} kecha",
  "tq.tours.who": "Kim boradi",
  "tq.tours.adults": "Kattalar",
  "tq.tours.childAges": "Bolalar yoshi (vergul bilan)",
  "tq.tours.quick": "Tez tanlash",
  "tq.tours.quickFrom": "{country} · dan {price}",
  "tq.country.title": "Davlat tanlash",
  "tq.country.charterOnly": "Faqat charter",
  "tq.country.directOnly": "To'g'ridan-to'g'ri reys",
  "tq.country.single": "Bitta davlat",
  "tq.country.multi": "Bir nechta davlat",
  "tq.country.search": "Davlatni qidirish",
  "tq.country.popular": "Mashhur — siz eng ko'p sotganlar",
  "tq.country.all": "Barcha davlatlar",
  "tq.country.done": "Tanlash",
  "tq.country.selected": "{count} ta davlat",
  "tq.calendar.title": "Narx kalendari",
  "tq.calendar.cheapest": "eng arzon kun",
  "tq.filter.resort": "Kurort",
  "tq.filter.anyResort": "Istalgan kurort",
  "tq.filter.level": "Mehmonxona darajasi",
  "tq.filter.stars": "{count} yulduz va yuqori",
  "tq.filter.board": "Ovqatlanish",
  "tq.filter.operators": "Turoperatorlar",
  "tq.filter.important": "Muhim",
  "tq.filter.seatsOnly": "Faqat joy borlar",
  "tq.filter.halalOnly": "Halol (manba bilan)",
  "tq.results.summary": "{hotels} mehmonxona · {operators} operatordan",
  "tq.sort.label": "Saralash",
  "tq.sort.cheapest": "Eng arzon",
  "tq.sort.rating": "Reyting",
  "tq.sort.bestseller": "Biz ko'p sotgan",
  "tq.sort.nearCenter": "Markazga yaqin",
  "tq.showNetto": "Netto ko'rsatish",
  "tq.card.cheapest": "eng arzon",
  "tq.card.stars": "{count} yulduz",
  "tq.card.placePhoto": "{place} surati, mehmonxona emas · {credit}",
  "tq.card.moreOperators": "Yana {count} ta operator narxi →",
  "tq.card.fewer": "Kamroq ko'rsatish",
  "tq.card.soldTimes": "Oxirgi oyda siz bu mehmonxonani {count} marta sotgansiz",
  "tq.card.details": "Batafsil",
  "tq.card.netto": "netto {netto} · foyda {profit}",
  "tq.card.nights": "{count} kecha",
  "tq.avail.flightYes": "Reysda joy bor",
  "tq.avail.flightFew": "Reysda joy kam",
  "tq.avail.flightNo": "Reysda joy yo'q",
  "tq.avail.hotelGuaranteed": "Mehmonxonada kafolat",
  "tq.avail.hotelRequest": "Mehmonxona so'rov bo'yicha",
  "tq.hotels.city": "Shahar yoki mehmonxona",
  "tq.hotels.checkIn": "Kirish",
  "tq.hotels.checkOut": "Chiqish",
  "tq.hotels.nightsAuto": "{count} kecha",
  "tq.hotels.guests": "Mehmonlar",
  "tq.hotels.hint": "Shahar va sanalarni kiriting, keyin Topish tugmasini bosing.",
  "tq.hotels.unsupported": "Mehmonxona yetkazib beruvchisi ulanmagan, shuning uchun bu qidiruv hozircha ishlamaydi.",
  "tq.hotels.empty": "Bu sanalarga mehmonxona topilmadi.",
  "tq.hotels.perNight": "1 kecha",
  "tq.hotels.total": "jami {total}",
  "tq.hotels.freeCancel": "Bepul bekor qilish — {date}gacha",
  "tq.hotels.nonRefundable": "Qaytarilmaydigan tarif",
  "tq.hotels.suppliers": "Yetkazib beruvchilar",
  "tq.hotels.area": "Hudud",
  "tq.hotels.conditions": "Shartlar",
  "tq.hotels.freeCancelFilter": "Bepul bekor qilish",
  "tq.hotels.breakfast": "Nonushta kiritilgan",
  "tq.hotels.instant": "Darhol tasdiqlash",
  "tq.hotels.nearBeach": "Plyajga yaqin",
  "tq.hotels.pricePerNight": "Bir kecha narxi",
  "tq.hotels.priceMax": "gacha",
  "tq.hotels.map": "Xarita",
  "tq.hotels.mapLarger": "Kattaroq xarita",
  "tq.hotels.mapSmaller": "Kichikroq xarita",
  "tq.hotels.mapNoPoints": "Natijalarning koordinatasi yo'q.",
  "tq.hotels.beach": "plyajgacha {meters} m",
  "tq.hotels.center": "markazgacha {km} km",
  "tq.hot.from": "Qayerdan",
  "tq.hot.within": "Uchishgacha",
  "tq.hot.days": "{count} kun",
  "tq.hot.budget": "2 kishiga, gacha",
  "tq.hot.updated": "● {minutes} daqiqa oldin yangilandi",
  "tq.hot.updatedNow": "● hozirgina yangilandi",
  "tq.hot.allCountries": "Hammasi",
  "tq.hot.banner": "Bu takliflarga mos {count} ta mijozingiz bor",
  "tq.hot.bannerOpen": "Mos mijozlarni ko'rish",
  "tq.hot.empty": "Hozircha qaynoq taklif yo'q.",
  "tq.hot.seatsLeft": "{count} joy qoldi",
  "tq.hot.matched": "{count} ta mos mijoz",
  "tq.hot.observed": "eski narx {date} kuni ko'rilgan",
  "tq.hot.sendToClient": "Mijozga yuborish",
  "tq.hot.today": "Bugun, {time}",
  "tq.hot.tomorrow": "Ertaga, {time}",
  "tq.hot.inDays": "{days} kundan keyin, {time}",
  "tq.hot.departed": "Uchib ketgan",
  "tq.hot.matchesTitle": "Mos mijozlar",
  "tq.hot.consentNote": "Faqat xabar olishga rozilik bergan mijozlarga yuboriladi.",
  "tq.hot.noConsent": "Rozilik yo'q — yuborilmaydi",
  "tq.hot.blocked": "Xabar tayyorlanmadi: {reason}",
  "tq.hot.sendSelected": "Tanlanganlarga yuborish",
  "tq.hot.sent": "{queued} ta xabar navbatga qo'yildi, {skipped} ta rozilik yo'qligi uchun o'tkazildi",
  "tq.hot.noMatches": "Bu taklifga mos mijoz yo'q.",
  "tq.hot.pickOffer": "Taklif",
  "tq.avia.roundTrip": "Borib-kelish",
  "tq.avia.oneWay": "Bir tomonga",
  "tq.avia.multi": "Murakkab marshrut",
  "tq.avia.multiNote": "Murakkab marshrutni hamkor saytida tuzing: narx manbasi faqat oddiy yo'nalishni qidiradi.",
  "tq.avia.swap": "Qayerdan va Qayerga almashtirish",
  "tq.avia.direct": "Faqat to'g'ridan-to'g'ri",
  "tq.avia.baggage": "Bagaj bilan",
  "tq.avia.flex": "Sanalar ±3 kun",
  "tq.avia.best.cheapest": "Eng arzon",
  "tq.avia.best.fastest": "Eng tez",
  "tq.avia.best.optimal": "Optimal",
  "tq.avia.stops": "Peresadkalar",
  "tq.avia.stopsDirect": "To'g'ridan-to'g'ri",
  "tq.avia.stopsOne": "1 ta peresadka",
  "tq.avia.stopsMany": "2+ peresadka",
  "tq.avia.airlines": "Aviakompaniyalar",
  "tq.avia.departTime": "Uchish vaqti",
  "tq.avia.airports": "Aeroport",
  "tq.avia.night": "Tun (00–06)",
  "tq.avia.morning": "Ertalab (06–12)",
  "tq.avia.day": "Kunduz (12–18)",
  "tq.avia.evening": "Kechqurun (18–24)",
  "tq.avia.buy": "Sotib olish ↗",
  "tq.pkg.new": "+ Yangi paket",
  "tq.pkg.kpi.active": "Faol paketlar",
  "tq.pkg.kpi.sold": "Sotilgan joylar",
  "tq.pkg.kpi.revenue": "Tushum (brutto)",
  "tq.pkg.kpi.margin": "O'rtacha ustama",
  "tq.pkg.kpi.top": "Eng ko'p sotilgan",
  "tq.pkg.tab.active": "Faol",
  "tq.pkg.tab.draft": "Qoralama",
  "tq.pkg.tab.archived": "Arxiv",
  "tq.pkg.search": "Paketni qidirish",
  "tq.pkg.empty": "Bu bo'limda paket yo'q.",
  "tq.pkg.sold": "{sold} / {quota} joy sotildi · {pct}%",
  "tq.pkg.perPerson": "1 kishiga",
  "tq.pkg.edit": "Tahrirlash",
  "tq.pkg.seatsLeft": "{count} joy",
  "tq.pkg.tag.hit": "Xit",
  "tq.pkg.tag.family": "Oilaviy",
  "tq.pkg.tag.new": "Yangi",
  "tq.pkg.tag.umrah": "Umra",
  "tq.pkg.tag.none": "Tegsiz",
  "tq.pkg.form.newTitle": "Yangi paket",
  "tq.pkg.form.editTitle": "Paketni tahrirlash",
  "tq.pkg.form.name": "Nomi",
  "tq.pkg.form.country": "Davlat",
  "tq.pkg.form.tag": "Teg",
  "tq.pkg.form.included": "Kiruvchi xizmatlar (vergul bilan)",
  "tq.pkg.form.description": "Qisqa tavsif",
  "tq.pkg.form.nights": "Kechalar soni",
  "tq.pkg.form.netto": "Netto",
  "tq.pkg.form.markup": "Ustama, %",
  "tq.pkg.form.brutto": "Brutto: {price}",
  "tq.pkg.form.price": "Narx (brutto)",
  "tq.pkg.form.currency": "Valyuta",
  "tq.pkg.form.images": "Rasm havolalari (har biri yangi qatorda, https://)",
  "tq.pkg.form.departures": "Chiqish sanalari",
  "tq.pkg.form.departureDate": "Sana",
  "tq.pkg.form.seats": "Joylar soni",
  "tq.pkg.form.addDeparture": "+ Sana qo'shish",
  "tq.pkg.form.status": "Holat",
  "tq.pkg.form.saved": "Paket saqlandi",
  "tq.pkg.form.failed": "Paketni saqlab bo'lmadi",
  "tq.pkg.send": "Mijozga yuborish",
  "tq.pkg.noDepartures": "Chiqish sanasi yo'q",
  "tq.pkg.netto": "netto {price}",
  "tq.pkg.form.removeDeparture": "Sanani olib tashlash",
  "tq.sel.title": "Tanlov",
  "tq.sel.empty": "Tanlov bo'sh. Natijalardagi «+ Tanlov» tugmasini bosing.",
  "tq.sel.remove": "Olib tashlash",
  "tq.sel.send": "Mijozga yuborish",
  "tq.sel.telegram": "Telegram xabar",
  "tq.sel.pdf": "PDF",
  "tq.sel.bruttoOnly": "Mijozga faqat brutto narx boradi.",
  "tq.sel.sent": "Telegram xabar navbatga qo'yildi",
  "tq.sel.failed": "Yuborib bo'lmadi",
  "tq.sel.kind.tour": "Tur",
  "tq.sel.kind.hotel": "Mehmonxona",
  "tq.sel.kind.hot": "Qaynoq tur",
  "tq.sel.kind.avia": "Aviabilet",
  "tq.sel.kind.package": "Paket",
  "bron.title": "Bronlar",
  "bron.subtitle": "Barcha turoperatorlardagi bronlar bir joyda · {count} ta operator ulangan",
  "bron.fromSearch": "+ Tur qidiruvidan bron",
  "bron.alert.title": "{count} ta muhim xabar — turistlarga hali aytilmagan",
  "bron.alert.informed": "Turistlarga aytildi",
  "bron.alert.informedBy": "{name} · {time}",
  "bron.alert.clientMessage": "Mijozga xabar",
  "bron.ops.all": "Hammasi",
  "bron.ops.updated": "{minutes} daq oldin yangilandi",
  "bron.ops.updatedNever": "Hali sinxronlanmagan",
  "bron.ops.broken": "Ulanish uzildi — qayta kiring",
  "bron.ops.counts": "{bookings} bron · {messages} xabar",
  "bron.ops.debt": "Qarz: {amount}",
  "bron.ops.refund": "Qaytarish: {amount}",
  "bron.ops.cabinet": "Kabinetga kirish ↗",
  "bron.ops.reconnect": "Qayta ulash ↗",
  "bron.ops.add": "+ Operator ulash",
  "bron.reconnect.title": "{operator} — qayta ulash",
  "bron.reconnect.login": "Login",
  "bron.reconnect.password": "Parol",
  "bron.reconnect.submit": "Ulash",
  "bron.reconnect.ok": "Ulanish tiklandi",
  "bron.reconnect.failed": "Ulanib bo'lmadi",
  "bron.filter.search": "Bron №, turist yoki mijoz",
  "bron.filter.operator": "Operator",
  "bron.filter.status": "Holat",
  "bron.filter.anyStatus": "Har qanday holat",
  "bron.filter.next30": "Uchish: keyingi 30 kun",
  "bron.filter.newOnly": "Faqat yangi xabari borlar",
  "bron.col.booking": "Bron № · operator",
  "bron.col.tour": "Tur · mijoz",
  "bron.col.dates": "Sanalar · turistlar",
  "bron.col.status": "Holat",
  "bron.col.payment": "Operatorga to'lov",
  "bron.col.messages": "Xabarlar",
  "bron.messagesButton": "Xabarlar · {count}",
  "bron.linkDeal": "Bitimga bog'lash",
  "bron.linkDealTitle": "Bronni bitimga bog'lash",
  "bron.linkDealPick": "Bitim",
  "bron.linked": "Bitimga bog'landi",
  "bron.deal": "Bitim №{number}",
  "bron.travellers": "{count} turist",
  "bron.empty": "Bu filtr bo'yicha bron yo'q.",
  "bron.panel.openSite": "Operator saytida ochish ↗",
  "bron.panel.close": "Panelni yopish",
  "bron.topic.all": "Hammasi",
  "bron.topic.booking": "Bronlash",
  "bron.topic.avia": "Avia",
  "bron.topic.payment": "To'lov",
  "bron.topic.documents": "Hujjatlar",
  "bron.panel.aiNote": "AI izohi",
  "bron.panel.summary": "AI qisqacha",
  "bron.panel.noSummary": "Bu xabarlar uchun qisqacha hali yo'q.",
  "bron.panel.prepareClient": "Mijozga xabar tayyorlash",
  "bron.panel.draftBlocked": "Xabar tayyorlanmadi: {reason}",
  "bron.panel.noMessages": "Bu bron bo'yicha xabar yo'q.",
  "bron.panel.replyTopic": "Mavzu",
  "bron.panel.replyUz": "Javobni o'zbekcha yozing",
  "bron.panel.translate": "Ruschaga tarjima",
  "bron.panel.translated": "Operatorga boradigan matn (rus tilida)",
  "bron.panel.send": "Operatorga yuborish",
  "bron.panel.sent": "Operatorga yuborildi",
  "bron.panel.replyOnSite": "Bu operatorga javob faqat saytda yoziladi",
  "bron.panel.passport": "Pasport",
  "bron.panel.important": "Muhim",
  "bron.ops.label": "Ulangan operatorlar",
  "bron.alert.open": "Bronni ochish",
  "katalog.title": "Katalogni moslashtirish",
  "katalog.badge": "Faqat egasi va admin",
  "katalog.banner": "Har bir operator yo'nalish, mehmonxona, ovqatlanish va xonani o'zicha nomlaydi. Kapitan ularni bizning katalogga moslaydi. Ishonchlilik 90% dan past bo'lsa, moslashni siz tasdiqlaysiz. Katalogda topilmaganlar qidiruvda chiqmaydi.",
  "katalog.tab.destination": "Yo'nalishlar",
  "katalog.tab.hotel": "Mehmonxonalar",
  "katalog.tab.board": "Ovqatlanish turlari",
  "katalog.tab.room": "Xona turlari",
  "katalog.kpi.matched": "Moslashtirilgan",
  "katalog.kpi.review": "Tekshirish kerak",
  "katalog.kpi.unmatched": "Katalogda topilmadi",
  "katalog.kpi.unmatchedHint": "bu turlar qidiruvda chiqmaydi",
  "katalog.kpi.lastSync": "Oxirgi sinxronlash",
  "katalog.kpi.never": "Hali yo'q",
  "katalog.filter.operator": "Operator",
  "katalog.filter.allOperators": "Barcha operatorlar",
  "katalog.filter.reviewFirst": "Avval tekshirish kerak bo'lganlar",
  "katalog.filter.search": "Nomi bo'yicha qidirish",
  "katalog.col.operator": "Operator",
  "katalog.col.external": "Operatordagi nomi",
  "katalog.col.catalog": "Bizning katalogda",
  "katalog.col.confidence": "Ishonchlilik",
  "katalog.col.action": "Harakat",
  "katalog.notFound": "Topilmadi",
  "katalog.accept": "Tasdiqlash",
  "katalog.change": "O'zgartirish",
  "katalog.addEntry": "Katalogga qo'shish",
  "katalog.changeTitle": "Moslashni o'zgartirish",
  "katalog.changeId": "Katalog yozuvi ID raqami",
  "katalog.reject": "Moslash noto'g'ri",
  "katalog.saved": "Saqlandi",
  "katalog.empty": "Bu bo'limda moslash yo'q.",
  "opconn.title": "Turoperatorlar",
  "opconn.subtitle": "Turoperatorlar, mehmonxona yetkazib beruvchilari va aviabilet hamkori: kirish ma'lumotlari, holat va imkoniyatlar.",
  "opconn.group.tour": "Turoperatorlar",
  "opconn.group.hotel": "Mehmonxona yetkazib beruvchilari",
  "opconn.group.avia": "Aviabiletlar hamkori",
  "opconn.capabilities": "Imkoniyatlar",
  "opconn.lastSync": "Oxirgi sinxronlash: {time}",
  "opconn.lastSyncNever": "Hali sinxronlanmagan",
  "opconn.health.ok": "Ishlayapti",
  "opconn.health.failing": "Xato",
  "opconn.health.unknown": "Tekshirilmagan",
  "opconn.test": "Ulanishni tekshirish",
  "opconn.testOk": "Ulanish ishlayapti",
  "opconn.testFailed": "Ulanish ishlamayapti: {detail}",
  "opconn.add": "+ Kirish qo'shish",
  "opconn.rotate": "Parolni almashtirish",
  "opconn.deactivate": "O'chirish",
  "opconn.inactive": "O'chirilgan",
  "opconn.noCredential": "Kirish ma'lumoti yo'q",
  "opconn.form.provider": "Yetkazib beruvchi",
  "opconn.form.login": "Login",
  "opconn.form.password": "Parol",
  "opconn.form.newPassword": "Yangi parol",
  "opconn.saved": "Saqlandi",
  "opconn.failed": "Saqlab bo'lmadi",
  "opconn.deactivateConfirm": "Bu kirish o'chiriladi va undan qidiruv qilinmaydi.",
  "opconn.empty": "Yetkazib beruvchi ro'yxati bo'sh.",
} as const;

export type TranslationKey = keyof typeof uz;
